import {useStaticAssetsUrl} from '@tinct/core-utils';
import {useConnectedUser} from '@tinct/core-store-session';

export const PreviewChatEmpty = () => {
  const assetsUrl = useStaticAssetsUrl();
  const connectedUser = useConnectedUser();
  const firstName = connectedUser?.firstName ?? '';

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="h-24 w-24 shrink-0 overflow-hidden rounded-full bg-indigo-500">
        <img
          src={`${assetsUrl}/tinct-avatar.png`}
          alt=""
          className="size-full object-cover"
        />
      </div>
      <div className="flex flex-col text-center">
        <p className="font-heading text-xl font-semibold tracking-tight text-foreground">
          {firstName ? `Hi ${firstName}` : 'Hi'}
        </p>
        <p className="text-sm text-foreground">
          What can I help with?
        </p>
      </div>
    </div>
  );
};
